<template>
  <div id="aba-sigef">
    <!-- Sub-abas -->
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <a class="nav-link" :class="{active: subAba === 'sigef'}" href="#" @click.prevent="subAba = 'sigef'">SIGEF</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: subAba === 'poligono'}" href="#" @click.prevent="subAba = 'poligono'">Polígono</a>
      </li>
    </ul>

    <!-- Sub-aba SIGEF — apenas importação CSV -->
    <template v-if="subAba === 'sigef'">
      <card titulo="Importação SIGEF">
        <template #acoes>
          <template v-if="itens.length && !loading">
            <v-button :run="remover" :button="false" :popover="true" position="dropleft"
                      class="icon mx-1 float-right">REMOVER TODOS</v-button>
          </template>

          <template v-else-if="sigefForm.hash">
            <a :href="urlLimites" target="_blank" class="float-right small" download="limites.csv">
              Download CSV Limites
            </a>
            <a :href="urlVertices" target="_blank" class="float-right mr-4 small" download="vertices.csv">
              Download CSV Vértices
            </a>
          </template>
        </template>

        <small-loading v-if="loading"></small-loading>

        <card-table v-if="itens.length && !loading">
          <thead>
            <tr>
              <th>Do Vértice</th>
              <th>Ao Vértice</th>
              <th>Longitude</th>
              <th>Latitude</th>
              <th>Tipo</th>
              <th>Lado</th>
              <th>Confrontante</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item of itens" :key="item.id">
              <td>{{item.vertice}}</td>
              <td>{{item.destino}}</td>
              <td>{{item.longitudeDms}}</td>
              <td>{{item.latitudeDms}}</td>
              <td>{{item.tipo}}</td>
              <td>{{item.lado}}</td>
              <td width="180px" class="small">{{item.confrontante}}</td>
            </tr>
          </tbody>
        </card-table>

        <template v-if="!itens.length && !loading">
          <div v-if="!$root.isAuditorOnly" class="row gutters-xs">
            <v-input class="col" :error="validation.hash" v-model="sigefForm.hash" placeholder="Hash de autenticação (Certificação)" type="text"/>

            <div class="col-3">
              <v-upload v-model="sigefForm.vertice" extensions="csv" class="form-control icon" :class="{'planilha-error': validation.vertice}">
                <i class="fal fa-file-excel"></i> CSV Vértices
              </v-upload>
            </div>

            <div class="col-3">
              <v-upload v-model="sigefForm.limite" extensions="csv" class="form-control icon" :class="{'planilha-error': validation.limite}">
                <i class="fal fa-file-excel mr-1"></i> CSV Limites
              </v-upload>
            </div>

            <div class="col-auto">
              <v-button :run="importar" :popover="true" position="dropleft"
                        class="btn btn-outline-secondary btn-xs">CADASTRAR</v-button>
            </div>
          </div>

          <div class="alert alert-outline-info">
            Não há itens para exibir
          </div>
        </template>

      </card>
    </template>

    <!-- Sub-aba Polígono — formulário unificado -->
    <template v-if="subAba === 'poligono'">

      <card titulo="Georreferenciamento e Polígono">
        <template #acoes>
          <a class="icon mx-1 float-right" title="Editar" @click.prevent="editar()" v-if="!emEdicao">
            <i class="fal fa-edit"></i>
          </a>
        </template>

        <card-content class="row">

          <!-- Seção: Georreferenciamento -->
          <div class="col-12">
            <label class="form-label mb-2">Possui Georreferenciamento?</label>
            <v-input
              v-model="form.possuiGeorreferenciamento"
              type="radio"
              :disabled="!emEdicao"
              :class="{'not-allowed' : !emEdicao}"
            />
          </div>

          <div class="col-4 mt-2">
            <label for="check-provimento-geo" style="margin-left: 4%; margin-top: 6%">
              <input id="check-provimento-geo" type="checkbox" v-model="form.adequadoProvimento195" class="mt-2 mr-1" :disabled="!emEdicao">
              Adequado para o Provimento 195/CNJ
            </label>
          </div>
          <div class="col-8 mt-2">
            <v-input type="v-select" :options="listaTiposSigef"
                     v-model="form.tipoSig" label="Tipo SIG-RI"
                     :disabled="!emEdicao"
                     :class="{'not-allowed' : !emEdicao}"/>
          </div>

          <!-- Seção: Polígono (condicional a possuiGeorreferenciamento) -->
          <template v-if="form.possuiGeorreferenciamento">
            <div class="col-12 mt-3"><hr class="my-0"></div>

            <!-- Número do Polígono -->
            <div class="col-md-4 mt-2">
              <v-input v-model="form.numeroPoligono" label="Número do Polígono" type="text" :disabled="!emEdicao" :inputProps="{ 'maxlength': 10 }" />
            </div>
            <!-- Descrição do Polígono -->
            <div class="col-md-8 mt-2">
              <v-input v-model="form.descricaoPoligono" label="Descrição do Polígono" type="text" :disabled="!emEdicao" />
            </div>
            <!-- Categoria -->
            <div class="col-md-4 mt-2">
              <v-input v-model="form.categoriaPoligono" label="Categoria" type="select"
                       :options="categoriaPoligonoOptions" :disabled="!emEdicao" />
            </div>
            <!-- QR Code SIG - RI -->
            <div class="col-md-4 mt-2">
              <v-input v-model="form.georreferenciamentoQr" label="QR Code SIG - RI" type="text"
                       placeholder="QR Code SIG - RI" :disabled="!emEdicao" />
            </div>
            <!-- Imagem QR Code SIG - RI -->
            <div class="col-md-4 mt-2" v-if="emEdicao || ficha.qrCodePoligonoImagem">
              <label class="form-label">Imagem QR Code SIG - RI</label>
              <div class="d-flex align-items-center">
                <template v-if="ficha.qrCodePoligonoImagem">
                  <div class="d-flex align-items-center">
                    <a :href="ficha.qrCodePoligonoImagem" download="qr-code-sig-ri" title="Baixar imagem">
                      <img :src="ficha.qrCodePoligonoImagem" alt="QR Code"
                           style="max-width: 40px; max-height: 40px; cursor: pointer; border-radius: 4px;" />
                    </a>
                    <v-button v-if="emEdicao" :run="excluirQrCode" :popover="true" :button="false" class="icon text-danger ml-2" title="Excluir">
                      <i class="fal fa-trash"></i>
                    </v-button>
                  </div>
                </template>
                <v-upload v-if="emEdicao && !ficha.qrCodePoligonoImagem" v-model="qrCodeFile" extensions="jpg,png,gif,jpeg" class="form-control icon" style="max-width: 250px;"
                          @input="onQrCodeFileSelected">
                  <i class="fal fa-image mr-1"></i> Selecionar Imagem
                </v-upload>
              </div>
            </div>
            <!-- Sistema de Coordenadas -->
            <div class="col-md-4 mt-2">
              <v-input v-model="form.sistemaCoordenadas" label="Sistema de Coordenadas" type="select"
                       :options="sistemaCoordenadasOptions" :disabled="!emEdicao" />
            </div>
            <!-- Sistema de Referência -->
            <div class="col-md-4 mt-2">
              <v-input v-model="form.sistemaReferencia" label="Sistema de Referência" type="select"
                       :options="sistemaReferenciaOptions" :disabled="!emEdicao" />
            </div>
            <!-- Zona UTM (conditional) -->
            <div class="col-md-4 mt-2" v-if="form.sistemaCoordenadas === 'UTM'">
              <v-input v-model="form.zonaUtm" label="Zona UTM" type="select"
                       :options="zonaUtmOptions" :disabled="!emEdicao" />
            </div>
            <!-- Formato -->
            <div class="col-md-4 mt-2">
              <v-input v-model="form.formatoPoligono" label="Formato" type="select"
                       :options="formatoPoligonoOptions" :disabled="!emEdicao" />
            </div>

            <!-- Coordenadas (visualização e edição) -->
            <template v-if="form.formatoPoligono === 'COORDENADAS'">
              <div class="col-12 mt-2">
                <label class="form-label">
                  Coordenadas do Georreferenciamento
                  <i v-if="emEdicao" class="fal fa-info-circle ml-1 text-primary" style="cursor: pointer;"
                     @click="mostrarAjudaCoordenadas"></i>
                </label>
                <textarea v-if="emEdicao"
                  rows="6"
                  v-model="form.coordenadas"
                  placeholder="lon,lat;lon,lat;lon,lat;lon,lat (fechar o polígono repetindo o primeiro ponto)"
                  class="form-control form-control-xs"
                />
                <textarea v-else
                  rows="6"
                  :value="ficha.georreferenciamento || ''"
                  disabled
                  class="form-control form-control-xs not-allowed"
                />
              </div>
            </template>
            <!-- GeoJSON -->
            <template v-if="form.formatoPoligono === 'GEOJSON'">
              <!-- Estado 1 — Visualização com arquivo salvo -->
              <div class="col-12 mt-2" v-if="!emEdicao && (ficha.nomeArquivoGeojson || ficha.georreferenciamento)">
                <label class="form-label">Arquivo GeoJSON</label>
                <div class="d-flex align-items-center">
                  <a href="#" @click.prevent="downloadGeojson" class="text-primary">
                    <i class="fal fa-file-code mr-1"></i> {{ ficha.nomeArquivoGeojson || 'Arquivo GeoJSON' }}
                  </a>
                </div>
              </div>
              <!-- Estado 2 — Edição com arquivo salvo -->
              <div class="col-12 mt-2" v-if="emEdicao && (ficha.nomeArquivoGeojson || ficha.georreferenciamento) && !geojsonFileName && !geojsonLimpo">
                <label class="form-label">Arquivo GeoJSON</label>
                <div class="d-flex align-items-center">
                  <span class="text-muted small mr-2"><i class="fal fa-file-code mr-1"></i> {{ ficha.nomeArquivoGeojson || 'GeoJSON carregado' }}</span>
                  <v-button :run="limparGeojson" :popover="true" :button="false" class="icon text-danger ml-2" title="Excluir">
                    <i class="fal fa-trash"></i>
                  </v-button>
                </div>
              </div>
              <!-- Estado 3 — Edição sem arquivo (ou após limpar) -->
              <div class="col-12 mt-2" v-if="emEdicao && ((!ficha.nomeArquivoGeojson && !ficha.georreferenciamento) || geojsonLimpo) && !geojsonFileName">
                <label class="form-label">Arquivo GeoJSON</label>
                <div class="d-flex align-items-center">
                  <v-upload v-model="geojsonFile" extensions="geojson,json" class="form-control icon" style="max-width: 300px;">
                    <i class="fal fa-file-code mr-1"></i> Selecionar Arquivo
                  </v-upload>
                </div>
              </div>
              <!-- Estado 4 — Edição com arquivo selecionado (pré-save) -->
              <div class="col-12 mt-2" v-if="emEdicao && geojsonFileName">
                <label class="form-label">Arquivo GeoJSON</label>
                <div class="d-flex align-items-center">
                  <span class="text-muted small"><i class="fal fa-file-code mr-1"></i> {{ geojsonFileName }}</span>
                  <v-button :run="removerGeojsonSelecionado" :popover="true" :button="false" class="icon text-danger ml-2" title="Remover">
                    <i class="fal fa-trash"></i>
                  </v-button>
                </div>
              </div>
            </template>

            <!-- Sobreposições -->
            <template v-if="sobreposicoes.length > 0">
              <div class="col-12 mt-3">
                <div class="alert alert-warning mb-0">
                  <i class="fal fa-exclamation-triangle mr-1"></i>
                  <strong>Sobreposição detectada</strong> com as seguintes matrículas:
                  <span v-for="(s, idx) in sobreposicoes" :key="'sob_'+idx">
                    {{ s[1] }}<span v-if="idx < sobreposicoes.length - 1">, </span>
                  </span>
                </div>
              </div>
            </template>
          </template>

          <!-- Botões de ação -->
          <div class="col-12 mt-3 d-flex justify-content-end" v-if="emEdicao">
            <button type="button" class="btn btn-outline-secondary btn-sm mr-2" @click="cancelarEdicao">Cancelar</button>
            <v-button :run="salvar" :popover="true" position="dropupleft" class="btn btn-primary btn-sm">
              <i class="fal fa-save mr-1"></i> Salvar
            </v-button>
          </div>
        </card-content>
      </card>

    </template>
  </div>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import SmallLoading from "@/components/SmallLoading";
import SigefBusiness from "@/business/SigefBusiness";
import ModalTexto from "@/components/ModalTexto.vue";

  export default {

    name: "Unidades",
    components: {SmallLoading, CardContent, CardTable, Card},
    props: {
      ficha: Object,
      ativa: { type: Boolean, default: true }
    },

    data() {
      return {
        loading: true,
        itens: [],
        subAba: 'sigef',
        sigefForm: {
          hash: null,
          limite: [],
          vertice: []
        },
        form: {
          possuiGeorreferenciamento: false,
          tipoSig: null,
          adequadoProvimento195: false,
          numeroPoligono: '',
          descricaoPoligono: '',
          categoriaPoligono: null,
          sistemaCoordenadas: 'GEOGRAFICA',
          sistemaReferencia: 'SIRGAS_2000',
          zonaUtm: null,
          formatoPoligono: null,
          coordenadas: '',
          geojsonContent: '',
          nomeArquivoGeojson: null,
          georreferenciamentoQr: ''
        },
        validation:{
          hash: null,
        },
        emEdicao: false,
        listaTiposSigef:[],
        sobreposicoes: [],
        qrCodeFile: [],
        geojsonFile: [],
        geojsonLimpo: false,
        categoriaPoligonoOptions: [
          {id: 'CATEGORIA_A', nome: 'Categoria A – Georreferenciados rurais com certificação ou urbanos com ART'},
          {id: 'CATEGORIA_B', nome: 'Categoria B – Georreferenciados rurais sem certificação e urbanos sem ART'},
          {id: 'CATEGORIA_C', nome: 'Categoria C – Desenho em imagem de satélite ou google earth'}
        ],
        sistemaCoordenadasOptions: [
          {id: 'GEOGRAFICA', nome: 'Geográfica'},
          {id: 'UTM', nome: 'UTM'}
        ],
        sistemaReferenciaOptions: [
          {id: 'SIRGAS_2000', nome: 'Sirgas 2000'},
          {id: 'SAD_69', nome: 'SAD/69'},
          {id: 'CORREGO_ALEGRE', nome: 'Córrego Alegre'},
          {id: 'ASTRO_CHUA', nome: 'Astro Chuá'},
          {id: 'NAO_INFORMADO', nome: 'Não Informado'}
        ],
        zonaUtmOptions: [
          {id: 'ZONA_18S', nome: '18 S'},
          {id: 'ZONA_19S', nome: '19 S'},
          {id: 'ZONA_20S', nome: '20 S'},
          {id: 'ZONA_21S', nome: '21 S'},
          {id: 'ZONA_22S', nome: '22 S'},
          {id: 'ZONA_23S', nome: '23 S'},
          {id: 'ZONA_24S', nome: '24 S'},
          {id: 'ZONA_25S', nome: '25 S'},
          {id: 'NAO_INFORMADO', nome: 'Não Informado'}
        ],
        formatoPoligonoOptions: [
          {id: 'GEOJSON', nome: 'GeoJSON/Desenho'},
          {id: 'COORDENADAS', nome: 'Coordenadas (Geo/UTM)'}
        ]
      }
    },

    async mounted() {
      await this.load();
    },

    computed:{
      urlLimites(){
        return `https://sigef.incra.gov.br/geo/exportar/limite/csv/${this.sigefForm.hash}/`;
      },
      urlVertices(){
        return `https://sigef.incra.gov.br/geo/exportar/vertice/csv/${this.sigefForm.hash}/`;
      },
      geojsonFileName() {
        if (this.geojsonFile && this.geojsonFile.length > 0 && this.geojsonFile[0] && this.geojsonFile[0].file) {
          return this.geojsonFile[0].file.name;
        }
        return null;
      }
    },

    watch: {
      ficha: {
        handler(newFicha) {
          if (newFicha && !this.emEdicao) {
            this.updateFormFromFicha(newFicha);
          }
        },
        immediate: true
      },
      ativa(val) {
        if (!val && this.emEdicao) {
          this.cancelarEdicao();
        }
      },
      subAba(val) {
        if (val !== 'poligono' && this.emEdicao) {
          this.cancelarEdicao();
        }
      },
      'form.formatoPoligono'(newVal, oldVal) {
        if (this.emEdicao && oldVal && newVal !== oldVal) {
          this.geojsonLimpo = true;
          this.geojsonFile = [];
          this.form.nomeArquivoGeojson = null;
        }
      }
    },

    methods: {

      async load(){
        this.loading = true;
        this.itens = await IndicadorRealBusiness.listarSigef(this.ficha.id).catch(e => ([]));
        this.updateFormFromFicha(this.ficha);
        this.listaTiposSigef = await SigefBusiness.listarTipoSig(this.ficha.categoria);

        if (this.ficha?.numeroPoligono) {
          this.sobreposicoes = await SigefBusiness.buscarSobreposicoes(this.ficha.id).catch(() => []);
        }

        this.loading = false;
      },

    editar() {
      this.emEdicao = true;
    },

    cancelarEdicao() {
      this.updateFormFromFicha(this.ficha);
      this.emEdicao = false;
      this.geojsonFile = [];
      this.geojsonLimpo = false;
      this.form.nomeArquivoGeojson = null;
    },

    updateFormFromFicha(ficha) {
      if (!ficha) return;
      this.form.possuiGeorreferenciamento = ficha.possuiGeorreferenciamento || false;
      this.form.tipoSig = ficha.tipoSig || null;
      this.form.adequadoProvimento195 = ficha.adequadoProvimento195 || false;
      this.form.numeroPoligono = ficha.numeroPoligono || '';
      this.form.descricaoPoligono = ficha.descricaoPoligono || '';
      this.form.categoriaPoligono = ficha.categoriaPoligono || null;
      this.form.sistemaCoordenadas = ficha.sistemaCoordenadas || 'GEOGRAFICA';
      this.form.sistemaReferencia = ficha.sistemaReferencia || 'SIRGAS_2000';
      this.form.zonaUtm = ficha.zonaUtm || null;
      this.form.formatoPoligono = ficha.formatoPoligono || null;
      this.form.coordenadas = (ficha.formatoPoligono === 'COORDENADAS' && ficha.georreferenciamento) ? ficha.georreferenciamento : '';
      this.form.geojsonContent = '';
      this.form.nomeArquivoGeojson = ficha.nomeArquivoGeojson || null;
      this.form.georreferenciamentoQr = ficha.georreferenciamentoQr || '';
    },

    downloadGeojson() {
      if (!this.ficha.georreferenciamento) return;
      const blob = new Blob([this.ficha.georreferenciamento], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.ficha.nomeArquivoGeojson || 'georreferenciamento.geojson';
      link.click();
      URL.revokeObjectURL(url);
    },

    async removerGeojsonSelecionado() {
      this.geojsonFile = [];
      this.geojsonLimpo = true;
    },

    async limparGeojson() {
      this.geojsonLimpo = true;
      this.form.coordenadas = '';
      this.form.geojsonContent = '';
      this.form.nomeArquivoGeojson = null;
    },

    lerArquivoTexto(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
      });
    },

    async salvar() {
      try {
        // Se formato GeoJSON e tem arquivo selecionado, ler o conteúdo
        if (this.form.formatoPoligono === 'GEOJSON' && this.geojsonFile && this.geojsonFile.length > 0 && this.geojsonFile[0] && this.geojsonFile[0].file) {
          const file = this.geojsonFile[0].file;
          const content = await this.lerArquivoTexto(file);
          this.form.geojsonContent = content;
          this.form.nomeArquivoGeojson = file.name;
        }

        await SigefBusiness.salvar(this.ficha.id, this.form);
        FrontBusiness.showSuccess('Sucesso', 'Dados salvos com sucesso');
        const fichaAtualizada = await IndicadorRealBusiness.getById(this.ficha.id);
        this.$emit('ficha-atualizada', fichaAtualizada);
        this.emEdicao = false;
        this.geojsonFile = [];
        this.geojsonLimpo = false;
        await this.load();
      } catch (error) {
        FrontBusiness.showError('Erro ao salvar', error.message);
      }
    },

    async onQrCodeFileSelected() {
      if (this.qrCodeFile && this.qrCodeFile.length > 0 && this.qrCodeFile[0] && this.qrCodeFile[0].file) {
        try {
          await SigefBusiness.uploadQrCode(this.ficha.id, this.qrCodeFile[0].file);
          FrontBusiness.showSuccess('Sucesso', 'Imagem do QR Code enviada');
          const fichaAtualizada = await IndicadorRealBusiness.getById(this.ficha.id);
          this.$emit('ficha-atualizada', fichaAtualizada);
          this.qrCodeFile = [];
          // Manter o estado de edição e os valores do formulário — não resetar
          this.$nextTick(() => {
            this.emEdicao = true;
          });
        } catch (error) {
          FrontBusiness.showError('Erro ao enviar imagem', error.message);
        }
      }
    },

    async excluirQrCode() {
      try {
        await SigefBusiness.excluirQrCode(this.ficha.id);
        FrontBusiness.showSuccess('Sucesso', 'Imagem do QR Code excluída');
        const fichaAtualizada = await IndicadorRealBusiness.getById(this.ficha.id);
        this.$emit('ficha-atualizada', fichaAtualizada);
        // Manter o estado de edição e os valores do formulário — não resetar
        this.$nextTick(() => {
          this.emEdicao = true;
        });
      } catch (error) {
        FrontBusiness.showError('Erro ao excluir imagem', error.message);
      }
    },

    ampliarQrCode() {
      if (this.ficha.qrCodePoligonoImagem) {
        window.open(this.ficha.qrCodePoligonoImagem, '_blank');
      }
    },

    mostrarAjudaCoordenadas() {
      const texto =
        '<h6>Como informar polígonos por Longitude e Latitude (Geográfica)</h6>' +
        '<p>Informe sempre na ordem: <b>longitude, latitude</b>.</p>' +
        '<p><b>Regras de preenchimento:</b></p>' +
        '<ul>' +
        '<li>Separe longitude e latitude por vírgula (<code>,</code>).</li>' +
        '<li>Separe cada par de coordenadas por ponto e vírgula (<code>;</code>).</li>' +
        '<li>O último par <b>não</b> deve terminar com ponto e vírgula.</li>' +
        '<li>Para fechar o polígono, o último par deve ser idêntico ao primeiro.</li>' +
        '<li>Utilize exclusivamente <b>Graus Decimais (DD)</b>.</li>' +
        '<li>Não são aceitos formatos em graus/minutos/segundos (DMS).</li>' +
        '</ul>' +
        '<p><b>Formatos válidos</b> (com ou sem quebra de linha):</p>' +
        '<pre style="font-size: 11px; white-space: pre-wrap;">-45.885711838106914, -23.174316973861238;\n-45.871229527357144, -23.184637319811642;\n-45.87010686760891, -23.179477246330222;\n-45.885711838106914, -23.174316973861238</pre>' +
        '<p>Ou em linha única:</p>' +
        '<pre style="font-size: 11px; white-space: pre-wrap;">-45.885711838106914,-23.174316973861238;-45.871229527357144,-23.184637319811642;-45.87010686760891,-23.179477246330222;-45.885711838106914,-23.174316973861238</pre>' +
        '<hr>' +
        '<h6>Como informar polígonos por UTM</h6>' +
        '<p>Antes de inserir as coordenadas, informe a <b>Zona UTM</b> (exemplo: 22S).</p>' +
        '<p>Informe sempre na ordem: <b>Leste (E), Norte (N)</b>.</p>' +
        '<p><b>Regras de preenchimento:</b></p>' +
        '<ul>' +
        '<li>Separe Leste e Norte por vírgula (<code>,</code>).</li>' +
        '<li>Separe cada par de coordenadas por ponto e vírgula (<code>;</code>).</li>' +
        '<li>O último par <b>não</b> deve terminar com ponto e vírgula.</li>' +
        '<li>Para fechar o polígono, o último par deve ser idêntico ao primeiro.</li>' +
        '<li>Informe apenas números em formato decimal.</li>' +
        '<li>A Zona UTM deve ser válida para o território brasileiro.</li>' +
        '</ul>' +
        '<p><b>Exemplo válido</b> (Zona UTM: 22S):</p>' +
        '<pre style="font-size: 11px; white-space: pre-wrap;">745123.45, 6945123.67;\n744980.12, 6944980.33;\n745210.89, 6944890.10;\n745123.45, 6945123.67</pre>' +
        '<p>Ou em linha única:</p>' +
        '<pre style="font-size: 11px; white-space: pre-wrap;">745123.45, 6945123.67; 744980.12, 6944980.33; 745210.89, 6944890.10; 745123.45, 6945123.67</pre>' +
        '<hr>' +
        '<p><b>Importante:</b> O polígono deve estar fechado (primeiro e último vértice idênticos). Não misture formatos no mesmo polígono.</p>';
      FrontBusiness.openModal(ModalTexto, { texto, titulo: 'Formato de Coordenadas' }, 800);
    },

        async importar(){

        let limites = null;
        let vertices = null;

      if(this.sigefForm.limite?.[0]?.file && this.sigefForm.vertice?.[0]?.file){
        limites = this.sigefForm.limite?.[0]?.file;
        vertices = this.sigefForm.vertice?.[0]?.file;
      }

        if(limites && vertices){

          const formData = new FormData();
          formData.append("limite", limites);
          formData.append("vertice", vertices);

          let config = {
            timeout: 0,
            headers: {
              'Content-Type': undefined
            },
          };

          await this.$api.post(`api/v2/sigef/${this.ficha.id}/importar/${this.sigefForm.hash}`, formData, config).catch(e => {
            FrontBusiness.showError('Erro ao importar SIGEF', e.message);
          });
        }else{
          await this.$api.get(`api/v2/sigef/${this.ficha.id}/importar/${this.sigefForm.hash}`).catch(e => {
            FrontBusiness.showError('Erro ao importar SIGEF', e.message);
          });
        }

        await this.load();

      },

      async remover(){
        await this.$api.delete(`api/v2/sigef/${this.ficha.id}`).catch(e => ([]));
        await this.load();
      }

    }
  }
</script>
<style scoped lang=scss>

  .td-toggle {
    text-align: right;
    vertical-align: top;
  }

  .table-unidades {
    .hidden-column {
      display: none;
    }

    &:hover {
      .hidden-column {
        display: initial;
      }
    }
  }

  #div-unidades-virtuais table thead th {
    line-height: 11px !important;
  }

.btn-square {
  width: 30px !important;
  height: 30px !important;
  padding: 6px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  i {
    margin: 0 !important;
  }
}
</style>
